// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__pZzMw","content":"LoadingAlert_content__3eWDy"};